export const getRuleConditionsByConditionType = (state) => state.globalData.ruleConditions.groupedByConditionType;
export const getRuleConditionsByConditionId = (state) => state.globalData.ruleConditions.groupedByConditionId;
